import {
  Avatar,
  Menu,
  Popover,
  SettingsIcon,
  Typography,
} from "@codat/orchard-ui";
import { UserState } from "api/public";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { getInitials } from "utils/getInitials";

import LogOutButton from "components/LogOutButton";

import { paths } from "../App/paths";
import styles from "./AvatarDropdown.module.scss";

interface AvatarDropdownProps {
  userState: UserState;
}

const AvatarDropdown = ({ userState }: AvatarDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const userInitials = getInitials(userState?.userName);
  const history = useHistory();

  const handleAccountSettingsClick = () => {
    history.push(paths.account.SETTINGS);
    setIsOpen(!isOpen);
  };

  return (
    <Popover
      data-testid="avatar-dropdown"
      className={styles.popoverSpacer}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      placement="bottom-end"
      removePadding
      alwaysInDom
      content={
        <Menu
          noPadding
          header={
            <div className={styles.menuHeader}>
              <Avatar size={40}>{userInitials}</Avatar>
              <div>
                <Typography
                  variant="heading_sm"
                  as="div"
                  className={styles.username}
                >
                  {userState?.userName}
                </Typography>
                <Typography variant="body_md" as="div" className={styles.role}>
                  {userState?.userRole}
                </Typography>
              </div>
            </div>
          }
        >
          <Menu.List>
            <Menu.Item
              id="account-settings-button"
              onClick={handleAccountSettingsClick}
              label="Account settings"
              icon={<SettingsIcon />}
              data-testid="account-settings-button"
            />
            <LogOutButton />
          </Menu.List>
        </Menu>
      }
    >
      <button
        className={styles.avatar}
        onClick={() => setIsOpen(!isOpen)}
        data-testid="avatar-dropdown-trigger"
      >
        <div
          className={isOpen ? styles.selectedAvatar : styles.unselectedAvatar}
        >
          <Avatar isSkeleton={false}>{userInitials}</Avatar>
        </div>
      </button>
    </Popover>
  );
};

export default AvatarDropdown;
